module.exports = __webpack_public_path__ + "static/media/chair-selected-small.a3ecde4d.png";